import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Content = function Content(props) {
  var name = props.name,
    label = props.label,
    iconSrc = props.iconSrc,
    _props$iconWidth = props.iconWidth,
    iconWidth = _props$iconWidth === void 0 ? 48 : _props$iconWidth,
    _props$iconHeight = props.iconHeight,
    iconHeight = _props$iconHeight === void 0 ? 48 : _props$iconHeight;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('content'),
    "data-t-id": "SharedBlock-Content"
  }, iconSrc && /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('icon'),
    height: iconHeight,
    src: iconSrc,
    width: iconWidth
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('text')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    variant: "body-small"
  }, label), /*#__PURE__*/React.createElement(Text, {
    color: "primary-invert",
    variant: "body-medium"
  }, name)));
};